



















import {Component, Vue, Prop} from 'vue-property-decorator';
import IconButton from '@c/controls/IconButton.vue';
import SelectField from '@c/controls/selectControls/SelectField.vue';
import {PModuleType} from '@/enums/configs';
import {moduleTypeFormComponentBindingMap} from '@/api/configurate';
import {PModule} from './interfaces';
import {VueConstructor} from 'vue';
import {pmoduleStoresByTypeMap} from './configurate';
import enumsModule from '@/store/modules/enumsModule';
import hardwareModule from '@/store/modules/entities/hardwareModule';

@Component({
  components: {
    SelectField,
    IconButton,
  },
})
export default class Module extends Vue {
  // Тип программного модуля
  moduleType!: PModuleType;

  // Идентификатор программного модуля
  moduleId!: string;

  // Идентификатор аппаратного модуля
  hardwareId!: string;

  // Тип аппаратного модуля
  hardwareType!: string;

  // Номер порта
  port!: string;

  // Имя порта
  portName!: string;

  // Программный модуль
  pmodule: PModule | null = null;

  @Prop({required: false})
  mac?: string;

  @Prop({required: false})
  hardwareName?: string;

  @Prop({required: false})
  fromHardware?: string;

  // Компонента формы параметров программного модуля
  formComponent: VueConstructor | null | undefined = null;

  typedPmoduleStoreModule!: any; //TODO:

  // Действия при сохранении
  async onSave() {
    if (this.pmodule) {
      let newModule;
      try {
        newModule = await this.typedPmoduleStoreModule.save(this.pmodule);

        if (this.hardwareId && this.port) {
          try {
            await hardwareModule.linkHM({
              hw_id: parseInt(this.hardwareId),
              pm_guid: newModule.guid,
              port: parseInt(this.port),
            });
          } catch (err) {
            console.log(err);
          }
        }
      } catch (err) {
        console.log(err);
      }
      if (this.hardwareId) this.$router.push({path: `/hardware/${this.hardwareId}`});
      else {
        this.$router.push({
          path: this.$router.currentRoute.matched[0].path,
        });
      }
    }
  }

  // Действия при отмене
  async onClose() {
    if (this.hardwareId) this.$router.push({path: `/hardware/${this.hardwareId}`});
    else {
      this.$router.push({
        path: this.$router.currentRoute.matched[0].path,
      });
    }
  }

  async created() {
    const currentModule = enumsModule.moduleTypes.filter(
      v => v.url === this.$router.currentRoute.params.type,
    );

    this.moduleType = currentModule[0].value as PModuleType;
    this.moduleId = this.$router.currentRoute.params.id;

    this.hardwareId = this.$router.currentRoute.params.hardware;
    this.hardwareType = this.$router.currentRoute.params.hardwareType;
    this.port = this.$router.currentRoute.params.port;
    this.portName = this.$router.currentRoute.params.portName;

    let moduleSettings = {};

    if (this.hardwareType) {
      const params = {
        port: parseInt(this.port),
        hw_type_id: parseInt(this.hardwareType),
        pm_type: this.$router.currentRoute.params.type,
      };
      const settings = await hardwareModule.getPMSettings(params);
      if (settings) {
        moduleSettings = settings;
      }
    }

    this.typedPmoduleStoreModule = pmoduleStoresByTypeMap.get(this.moduleType);

    if (this.moduleId) {
      const {data} = await this.typedPmoduleStoreModule.edit(this.moduleId);
      this.pmodule = data;
      if (this.pmodule) this.moduleType = this.pmodule.type;
    } else {
      const {data} = await this.typedPmoduleStoreModule.create();
      this.pmodule = {...data, ...moduleSettings};
    }

    const pmoduleName = enumsModule.moduleTypes.filter(x => x.value == this.moduleType)[0]
      .description;

    if (this.pmodule && this.fromHardware) {
      this.pmodule.name = `${this.hardwareName} - ${pmoduleName} (${this.portName} порт)`;
      this.pmodule.description = this.pmodule.name;
    }

    this.formComponent = moduleTypeFormComponentBindingMap.get(this.moduleType);
  }
}
